export class ContentConfig {
    constructor(
        public languages: Language[],
        public navigation: NavigationPage[],
        public footerLinks: NavigationPage[],
        public startPageNotice: StartPageNotice[]
    ) {}
}

export enum Language {
    DE = "DE",
    EN = "EN",
    PL = "PL",
    TR = "TR",
    ES = "ES",
    NL = "NL",
    FR = "FR",
    IT = "IT",
}

export enum NavigationPage {
    HOME = "HOME",
    CONTACT_FORM = "CONTACT_FORM",
    CONTACT_FORM_OLD = "CONTACT_FORM_OLD",
    CONTACT_DATA = "CONTACT_DATA",
    CONTACT_DATA_OLD = "CONTACT_DATA_OLD",
    RATE_AGREEMENT = "RATE_AGREEMENT",
    DOWNLOAD = "DOWNLOAD",
    HELP = "HELP",
    IMPRINT = "IMPRINT",
    IMPRINT_OLD = "IMPRINT_OLD",
    PRIVACY = "PRIVACY",
    PRIVACY_OLD = "PRIVACY_OLD",
    COOKIE_POLICY = "COOKIE_POLICY",
    EAA_PRIVACY = "EAA_PRIVACY",
    EAA_SIMPLE_LANGUAGE = "EAA_SIMPLE_LANGUAGE",
}

export enum StartPageBoxes {
    FAQ = "FAQ",
    CONTACT = "CONTACT",
    QUESTION = "QUESTION",
    DSGVO = "DSGVO",
}

export enum StartPageNotice {
    NOTICE = "NOTICE",
}
